import React from 'react';
import { Col, Grid, Row } from 'antd';
import ImageC from 'src/components/Image';
import cn from "src/utils/cn";

const point = [
	'Menumbuhkan sel baru untuk regenerasi organ atau jaringan yang rusak',
	'Digunakan untuk meneliti penyebab terjadinya penyakit',
	'Melihat risiko sebuah sel menjadi kanker',
];

const MoreInformation = () => {
	const { xl } = Grid.useBreakpoint();
	return (
		<div className="bg-gray">
			<div className="container py-3 md:py-12">
				<Row gutter={{ md: 60, xs: 0 }} justify="end">
					<Col className="flex justify-center md:justify-end" xs={24} md={12}>
						<div>
							<ImageC
								style={{ objectFit: 'contain' }}
								width={xl ? 512 : 320}
								height={xl ? 698 : 436}
								src="/images/stem-cell/cell-multiple.png"
							/>
						</div>
					</Col>
					<Col xs={24} md={12}>
						<h2 className="mb-6 text-5xl font-bold max-xl:text-2xl max-xs:text-center max-xs:mt-6 max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
							Potensi Penggunaan Stem Cell di Indonesia
						</h2>
						<p className="my-3 text-2xl max-xl:text-sm max-xs:leading-normal max-xs:text-neutral-5">
							<a href="https://www.regenic.co.id/" target="_blank">
								Stem cell di Indonesia
							</a>{' '}
							dikenal dengan sel punca, yang merupakan basis dari semu sel yang ada di dalam tubuh
							kita. Stem cell dapat merubah diri menjadi sel lain yang diyakini dapat membantu
							berbagai kondisi kesehatan, seperti:
						</p>
						{point.map((item: string, index: number) => (
							<Row className="mb-3" key={index} align="top">
								<Col className="flex md:pt-2" span={2}>
									<ImageC
										width={xl ? 24 : 18}
										height={xl ? 24 : 18}
										src="/images/stem-cell/icon-arrow-right.png"
									/>
								</Col>
								<Col span={22}>
									<p className="mb-0 text-2xl max-xl:text-sm max-xs:leading-normal max-xs:text-neutral-5">
										<span
											dangerouslySetInnerHTML={{
												__html: item,
											}}
										/>
									</p>
								</Col>
							</Row>
						))}
						<p className="text-sm max-md:text-xs max-md:text-neutral-5 italic">
							Referensi:Food & Drug Administrations. Diakses 2022. FDA Warns About Stem Cell
							Therapies. Stem Cell Investigation. Diakses 2022. Current state of stem cell-based
							therapies: an overview
						</p>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default MoreInformation;
